import { executeRequest, Request } from '@jfs/network'
import { getAPIURL, getPaymentHeader } from '../config'
const fetchConvenienceFee = (params: any, paymentSubType: Number) => {
  const request: Request<{}> = {
    apiPath: `${getAPIURL('convenienceFee')}`,
    method: 'POST',
    headers: getPaymentHeader(),
    body: params,
  }
  return executeRequest(request)
    .then((response) => {
      const { data } = response

      // const data = {
      //   entity: { initiatingEntityId: 2103, application: 8006, type: 12, entityId: '100001000217423' },
      //   feeDetails: [
      //     {
      //       method: { type: '110', subType: '579' },
      //       bankId: '2002',
      //       fee: {
      //         feeAttributes: [{ type: 0, value: 20.0, minimumAmount: 10.0, maximumAmount: 9.99999999e8 }],
      //         totalConvenienceFee: 20.0,
      //         feeTax: { cgst: 1.8, sgst: 1.8, igst: 0.0, ugst: 0.0, tcs: 0.0, tds: 0.0 },
      //         merchantShare: 'N',
      //       },
      //     },
      //     {
      //       method: { type: '110', subType: '579' },
      //       bankId: '2001',
      //       fee: {
      //         feeAttributes: [{ type: 0, value: 10.0, minimumAmount: 10.0, maximumAmount: 9.99999999e8 }],
      //         totalConvenienceFee: 10.0,
      //         feeTax: { cgst: 1.8, sgst: 1.8, igst: 0.0, ugst: 0.0, tcs: 0.0, tds: 0.0 },
      //         merchantShare: 'N',
      //       },
      //     },
      //   ],
      // }
      // const data = { code: 'RES_005', message: 'No Fee Rules mapped for the merchant ID' }
      // const data = {
      //   entity: {
      //     initiatingEntityId: 2103,
      //     application: 2103,
      //     type: 12,
      //     entityId: '100001000217423',
      //   },
      //   feeDetails: [
      //     {
      //       method: {
      //         type: 114,
      //         subType: 582,
      //       },
      //       bankId: '',
      //       card: {
      //         scheme: '104',
      //         type: '130',
      //         cardBin: '*',
      //       },
      //       fee: {
      //         feeAttributes: [
      //           {
      //             type: 'P',
      //             value: '7.00',
      //             minAmount: '0.00',
      //             maxAmount: '1000.00',
      //           },
      //           {
      //             type: 'F',
      //             value: '10.00',
      //             minimumAmount: '1000.01',
      //             maximumAmount: '2000.00',
      //           },
      //         ],
      //         totalConvenienceFee: '36.20',
      //         feeTax: {
      //           cgst: '2.10',
      //           igst: '2.10',
      //           sgst: '0.00',
      //           ugst: '0.00',
      //           tcs: '0.00',
      //           tds: '0.00',
      //         },
      //         merchantShare: 'N',
      //       },
      //     },
      //     {
      //       method: {
      //         type: 110,
      //         subType: 582,
      //       },
      //       bankId: '',
      //       card: {
      //         scheme: '105',
      //         type: '110',
      //         cardBin: '*',
      //       },
      //       fee: {
      //         feeAttributes: [
      //           {
      //             type: 'P',
      //             value: '7.00',
      //             minAmount: '0.00',
      //             maxAmount: '1000.00',
      //           },
      //           {
      //             type: 'F',
      //             value: '12.00',
      //             minimumAmount: '1000.01',
      //             maximumAmount: '2000.00',
      //           },
      //         ],
      //         totalConvenienceFee: '39.20',
      //         feeTax: {
      //           cgst: '2.10',
      //           igst: '2.10',
      //           sgst: '0.00',
      //           ugst: '0.00',
      //           tcs: '0.00',
      //           tds: '0.00',
      //         },
      //         merchantShare: 'N',
      //       },
      //     },
      //     {
      //       method: {
      //         type: 110,
      //         subType: 581,
      //       },
      //       bankId: '1038',
      //       fee: {
      //         feeAttributes: [
      //           {
      //             type: 'P',
      //             value: '7.00',
      //             minAmount: '0.00',
      //             maxAmount: '1000.00',
      //           },
      //           {
      //             type: 'F',
      //             value: '12.00',
      //             minimumAmount: '1000.01',
      //             maximumAmount: '2000.00',
      //           },
      //         ],
      //         totalConvenienceFee: '39.20',
      //         feeTax: {
      //           cgst: '2.10',
      //           igst: '2.10',
      //           sgst: '0.00',
      //           ugst: '0.00',
      //           tcs: '0.00',
      //           tds: '0.00',
      //         },
      //         merchantShare: 'N',
      //       },
      //     },
      //   ],
      // }
      return data
    })
    .catch((err) => {
      const {
        data: { error },
      } = err
      throw error
      // const data = { code: 'RES_005', message: 'No Fee Rules mapped for the merchant ID' }
      // switch (paymentSubType) {
      //   case PAYMENT_MODE_SUBTYPES.CARD:
      //     const data = {
      //       entity: {
      //         initiatingEntityId: 2103,
      //         application: 2103,
      //         type: 12,
      //         entityId: '100001000217423',
      //       },
      //       feeDetails: [
      //         {
      //           method: {
      //             type: 114,
      //             subType: 581,
      //           },
      //           bankId: '1038',
      //           fee: {
      //             feeAttributes: [
      //               {
      //                 type: 'P',
      //                 value: '7.00',
      //                 minAmount: '0.00',
      //                 maxAmount: '1000.00',
      //               },
      //               {
      //                 type: 'F',
      //                 value: '10.00',
      //                 minimumAmount: '1000.01',
      //                 maximumAmount: '2000.00',
      //               },
      //             ],
      //             totalConvenienceFee: '36.20',
      //             feeTax: {
      //               cgst: '2.10',
      //               igst: '2.10',
      //               sgst: '0.00',
      //               ugst: '0.00',
      //               tcs: '0.00',
      //               tds: '0.00',
      //             },
      //             merchantShare: 'N',
      //           },
      //         },
      //         {
      //           method: {
      //             type: 110,
      //             subType: 581,
      //           },
      //           bankId: '1038',
      //           fee: {
      //             feeAttributes: [
      //               {
      //                 type: 'P',
      //                 value: '7.00',
      //                 minAmount: '0.00',
      //                 maxAmount: '1000.00',
      //               },
      //               {
      //                 type: 'F',
      //                 value: '12.00',
      //                 minimumAmount: '1000.01',
      //                 maximumAmount: '2000.00',
      //               },
      //             ],
      //             totalConvenienceFee: '39.20',
      //             feeTax: {
      //               cgst: '2.10',
      //               igst: '2.10',
      //               sgst: '0.00',
      //               ugst: '0.00',
      //               tcs: '0.00',
      //               tds: '0.00',
      //             },
      //             merchantShare: 'N',
      //           },
      //         },
      //       ],
      //     }
      //     return data
      //   case PAYMENT_MODE_SUBTYPES.NB:
      //     const nbData = {
      //       entity: {
      //         initiatingEntityId: 2103,
      //         application: 2103,
      //         type: 12,
      //         entityId: '100001000217423',
      //       },
      //       feeDetails: [
      //         {
      //           method: {
      //             type: 114,
      //             subType: 581,
      //           },
      //           bankId: '1038',
      //           fee: {
      //             feeAttributes: [
      //               {
      //                 type: 'P',
      //                 value: '7.00',
      //                 minAmount: '0.00',
      //                 maxAmount: '1000.00',
      //               },
      //               {
      //                 type: 'F',
      //                 value: '10.00',
      //                 minimumAmount: '1000.01',
      //                 maximumAmount: '2000.00',
      //               },
      //             ],
      //             totalConvenienceFee: '36.20',
      //             feeTax: {
      //               cgst: '2.10',
      //               igst: '2.10',
      //               sgst: '0.00',
      //               ugst: '0.00',
      //               tcs: '0.00',
      //               tds: '0.00',
      //             },
      //             merchantShare: 'N',
      //           },
      //         },
      //         {
      //           method: {
      //             type: 110,
      //             subType: 581,
      //           },
      //           bankId: '1038',
      //           fee: {
      //             feeAttributes: [
      //               {
      //                 type: 'P',
      //                 value: '7.00',
      //                 minAmount: '0.00',
      //                 maxAmount: '1000.00',
      //               },
      //               {
      //                 type: 'F',
      //                 value: '12.00',
      //                 minimumAmount: '1000.01',
      //                 maximumAmount: '2000.00',
      //               },
      //             ],
      //             totalConvenienceFee: '39.20',
      //             feeTax: {
      //               cgst: '2.10',
      //               igst: '2.10',
      //               sgst: '0.00',
      //               ugst: '0.00',
      //               tcs: '0.00',
      //               tds: '0.00',
      //             },
      //             merchantShare: 'N',
      //           },
      //         },
      //       ],
      //     }
      //     return nbData
      //   default:
      //     const data1 = { code: 'RES_005', message: 'No Fee Rules mapped for the merchant ID' }
      //     return data1
      // }
    })
}
export { fetchConvenienceFee }
